<template>
    <div class="q-select" :class="{open: showMenu, disabled: disabled}" :disabled="disabled" ref="qSelect" @mouseleave="displayMenu(false)" @mouseenter="displayMenu(true)">
        <a class="dropdown-toggle" @click="onClick">
            <div class="display-label">{{$t(selectOption.label)}}</div>
            <div class="icon-triangle-down triangle" :class="{white: isWhite}" ></div>
        </a>
        <ul ref="optionsMenu" class="dropdown-menu" @mouseleave="displayMenu(false)" @mouseenter="displayMenu(true)">
          <scrollbar ref="scrollbar" class="scrollbar-body">
            <li :id="option.value" v-for="(option, index) in optionsArray" :title="($t(option.title) || $t(option.label))" :key="option.value" v-if="(option.rule && rule === option.rule) || !option.rule" @click="onOptionsClick(index, props)" :value="option.value" :class="{'disabled': option.isDisabled}" :disabled="option.isDisabled"><a>{{$t(option.label)}}</a></li>
          </scrollbar>
        </ul>
    </div>
</template>
<script>
export default {
  name: 'q-select',
  props: {
    rule: String,
    value: Number | String,
    props: {
      type: Number,
      default: -1
    },
    optionsArray: Array,
    isWhite: Boolean,
    isDisabled: Boolean
  },
  watch: {
    value: function (val) {
      for (let index in this.optionsArray) {
        if (this.optionsArray[index].value === this.value) {
          this.selectOption = {
            label: this.optionsArray[index].label,
            value: this.optionsArray[index].value
          }
        }
      }
    },
    optionsArray: function (val) {
      for (let index in this.optionsArray) {
        if (this.optionsArray[index].value === this.value) {
          this.selectOption = {
            label: this.optionsArray[index].label,
            value: this.optionsArray[index].value
          }
        }
      }
    },
    isDisabled: {
      handler (value) {
        this.disabled = value
      },
      immediate: true
    }
  },
  data () {
    return {
      disabled: false,
      displayHandle: null,
      showMenu: false,
      selectOption: {
        label: '',
        value: ''
      }
    }
  },
  created: function () {
    this.$log.info('select created')
    for (let index in this.optionsArray) {
      if (this.optionsArray[index].value === this.value) {
        this.selectOption = {
          label: this.optionsArray[index].label,
          value: this.optionsArray[index].value
        }
      }
    }
  },
  updated () {
    let selectElement = document.getElementById(this.value)
    this.$refs.scrollbar.delayScrollTo(selectElement)
    this.$refs.scrollbar.calculate()
  },
  methods: {
    displayMenu: function (display) {
      let self = this
      if (display) {
        if (self.displayHandle) {
          clearTimeout(self.displayHandle)
        }
      } else {
        self.displayHandle = setTimeout(() => {
          self.showMenu = false
        }, 500)
      }
    },
    onOptionsClick: function (index, props) {
      if (!this.optionsArray[index].isDisabled) {
        this.selectOption = this.optionsArray[index]
        this.showMenu = false
        this.$emit('change', this.selectOption.value, props)
      }
    },
    onClick: function (event) {
      if (!this.$attrs.disabled && !this.isDisabled) {
        let windowH = window.innerHeight
        let optionsH = (30 * this.optionsArray.length > 300) ? 300 : (30 * this.optionsArray.length)
        let cursorH = event.clientY
        this.showMenu = !this.showMenu
        if (cursorH + optionsH > windowH) {
          this.$refs.optionsMenu.style.height = (windowH - cursorH) - 30 + 'px'
        } else {
          this.$refs.optionsMenu.style.top = 'initial'
        }
        let selectElement = document.getElementById(this.value)
        this.$refs.scrollbar.delayScrollTo(selectElement)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.q-select {
    position: relative;
    display: inline-block;
    width: 100px;
    height: 30px;
    border: 1px solid #979797;
    border-radius: 4px;
    vertical-align: middle;
    &:disabled, &.disabled {
        box-shadow: none;
        color: #AEAEAE !important;
        border: 1px solid #AEAEAE !important;
        > a, .display-label, .triangle {
          cursor: not-allowed;
          color: #AEAEAE !important;
        }
    }
    cursor: pointer;
    font-size: 16px;
    background: inherit !important;
    color: #000000;
    outline: none;
    padding-right: 25px;
    text-align: left;
    .dropdown-toggle {
        height: 100%;
        display: flex;
        color: #000000;
        text-decoration: none;
        width: calc(100% + 20px);
        padding: 0 12px !important;
        &:hover {
            color: #000000;
            text-decoration: none;
        }
    }
    .dropdown-menu {
      position: fixed !important;
      top: initial;
      left: initial !important;
      margin-top: 10px;
      min-width: inherit;
      background: #ffffff;
      border: 1px solid #D8D8D8;
      -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
      padding-top: 5px;
      padding-bottom: 5px;
      border: 1px solid #D8D8D8;
      box-shadow: 0 1px 2px 0 rgba(0,0,0,0.20);
      border-radius: 8px;
      max-height: 250px;
      .scrollbar-body {
        position: relative;
        height: calc(100% - 5px);
        max-height: 240px;
        .scroll-content > li {
          font-size: 12px;
          color: #000000;
          padding: 0 15px;
          line-height: 30px;
          cursor: pointer;
          &.static {
            padding: 0 22px;
            cursor: auto;
          }
          > a {
            color: #000000;
            padding: 0px;
            line-height: 30px;
            &:hover {
                background-color: #ECF6FC;
                text-decoration: none;
            }
            &:focus {
                color: #2f2f2f;
            }
          }
          &:hover {
            background-color: #ECF6FC;
          }
          &.disabled {
            font-size: 12px;
            color: #969696;
            cursor: not-allowed;
            // pointer-events: none;
            > a {
              cursor: not-allowed;
              color: #969696;
              pointer-events: none;
            }
          }
          &.disabled:hover {
            background-color: initial;
          }
        }
      }
    }
    .display-label {
        cursor: pointer;
        text-decoration: none;
        font-size: 13px;
        line-height: 30px;
        color: #2F2F2F;
        width: auto;
    }
    .triangle {
      cursor: pointer;
      pointer-events: none;
      display: inline-block;
      position: absolute;
      right: 5px;
      top: 4px;
      color: #000000;
      font-size: 20px;
      &.white {
        position: relative;
        color: #fff;
        margin: auto;
        left: 5px;
        top: initial;
      }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/module/Select.vue